module.exports = __webpack_public_path__ + "img/圆角矩形 1@2x (1).cc6eb47d.png";